// routes
// config
// components
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------
export const navConfig = [
  {
    title: 'Home',
    icon: <Iconify icon="solar:home-2-bold-duotone" />,
    path: '/#home-hero',
  },
  // {
  //   title: 'Testimonials',
  //   path: '#testimonials',
  //   icon: <Iconify icon="ic:baseline-info" />,
  // },
  
  // {
  //   title: 'FAQs',
  //   path: '#faqs',
  //   icon: <Iconify icon="akar-icons:question-fill" />,
  // }
];